import { createReducer, on } from '@ngrx/store';
import { CustomizeGuidelinesDTO } from '../models';
import { LoadGuidelines, ResetGuidelinesFilters, SetGuidelinesMultiSelectFilter, ToggleGuidelineSelection, SetGuidelinesUi, ClearGuidelinesUi } from './actions';
import { INIT_GUIDELINES_STATE } from './init-data';

export interface GuidelinesState {
  strategies: CustomizeGuidelinesDTO['strategies'];
  filters: {
    presets: string[];
    categories: string[];
  }
  categories: { id: string; filter: string; name: string; }[];
  presets: { id: string; filter: string; name: string; }[];
  selectedRows: Set<string>;
  ui: {
    openStrategyId: string | null;
    focusGuidelineId: string | null;
  }
}

const initialState = INIT_GUIDELINES_STATE;

export const guidelinesReducer = createReducer(
  initialState,
  on(LoadGuidelines, (state, { strategies, categories, presets }) => ({
    ...state, strategies, presets, categories
  })),
  on(ToggleGuidelineSelection, onToggleGuidelineSelection),
  on(SetGuidelinesMultiSelectFilter, (state, { filterType, selectedValues }) => ({
    ...state,
    filters: { ...state.filters, [filterType]: selectedValues }
  })),
  on(ResetGuidelinesFilters, (state) => ({
    ...state,
    filters: initialState.filters
  })),
  on(SetGuidelinesUi, (state, { openStrategyId, focusGuidelineId }) => ({
    ...state,
    ui: { openStrategyId, focusGuidelineId }
  })),
  on(ClearGuidelinesUi, (state) => ({
    ...state,
    ui: { openStrategyId: null, focusGuidelineId: null }
  })),
);

function onToggleGuidelineSelection(_: GuidelinesState, { id }: { id: string }) {
  const updatedSelection = new Set(_.selectedRows);
  updatedSelection.has(id) ? updatedSelection.delete(id) : updatedSelection.add(id);
  return { ..._, selectedRows: updatedSelection };
}
